import React, { useState, useEffect } from 'react';
import { Typography, Box } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { setBlockModeSwitch } from '../features/contestants/contestantsSlice';
import BackgroundContainer from './BackgroundContainer';
import CountdownTimer from './CountdownTimer';
import BaseButton from './BaseButton';
import DeeperCard from './DeeperCard';
import PopoverCard from './PopoverCard';

const btnSx = {
  whiteSpace: 'nowrap',
  flex: '1 1 0',
  minWidth: 0,
  fontSize: '0.9rem',
  padding: '10px 14px',
};

const TruthQuestionCard = ({ question, formattedTime, questionTimer, drinkQuestion, swapTurns, swapTurnsAndAddShot, swapSkippedTurns, setPlayerAddShotAndSwap, playerOne, playerTwo, attributes, typeOfDare }) => {
  const playerOneName = playerOne.name;
  const playerTwoName = playerTwo.name;
  const gameMode = useSelector((state) => state.contestants.gameMode);
  const dispatch = useDispatch();
  const [startCountDown, setStartCountDown] = useState(false);
  const [hideInitialText, setHideInitialText] = useState(false);
  const [hideFinalText, setHideFinalText] = useState(true);
  const [drinkConfirmOpen, setDrinkConfirmOpen] = useState(false);
  const [skipConfirmOpen, setSkipConfirmOpen] = useState(false);
  const [showPartnerPicks, setShowPartnerPicks] = useState(false);

  useEffect(() => {
    dispatch(setBlockModeSwitch(showPartnerPicks));
    return () => dispatch(setBlockModeSwitch(false));
  }, [showPartnerPicks]);

  const handleCountdownOver = () => { setHideFinalText(false); };
  const toggleTimer = () => { setHideFinalText(true); setHideInitialText(true); setStartCountDown(true); };

  const handleSkipConfirm = () => {
    setSkipConfirmOpen(false);
    setShowPartnerPicks(true);
  };

  const handlePartnerPicksDone = () => {
    setShowPartnerPicks(false);
    swapSkippedTurns();
  };

  if (showPartnerPicks) {
    return (
      <BackgroundContainer>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            paddingTop: '50px',
          }}
        >
          <DeeperCard
            typeOfDare="Truth"
            question="Your partner can pick any previous truth question from the game, or come up with an original of their own!"
            attributes={[]}
          />
          <BaseButton sx={{ marginTop: '20px' }} onClick={handlePartnerPicksDone}>Answered</BaseButton>
        </Box>
      </BackgroundContainer>
    );
  }

  return (
    <BackgroundContainer>
      <Box display={'flex'} justifyContent={'flex-end'} flexGrow={1}>
        {startCountDown && (
          <CountdownTimer
            duration={questionTimer}
            toggleTimer={toggleTimer}
            handleCountdownOver={handleCountdownOver}
            onGiveUp={setPlayerAddShotAndSwap}
            playerOne={playerOne}
            playerTwo={playerTwo}
          />
        )}
      </Box>

      {!hideInitialText && (
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%', paddingTop: '50px' }}>
          <Box width="100%" maxWidth="500px" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <DeeperCard typeOfDare={typeOfDare} question={question} attributes={attributes} />
            <Box marginTop={'15px'} display="flex" flexDirection="row" justifyContent="center" alignItems="center" gap="8px" width="100%">
              {gameMode === 'drink' ? (
                <BaseButton sx={btnSx} onClick={() => setDrinkConfirmOpen(true)}>Drink Instead</BaseButton>
              ) : (
                <BaseButton sx={btnSx} onClick={() => setSkipConfirmOpen(true)}>Skip Question</BaseButton>
              )}
              {questionTimer > 0 ? (
                <BaseButton sx={btnSx} onClick={toggleTimer}>({formattedTime}) Start</BaseButton>
              ) : (
                <BaseButton sx={btnSx} onClick={swapTurns}>I Answered</BaseButton>
              )}
            </Box>
          </Box>
        </Box>
      )}

      <Box display={'flex'} justifyContent={'flex-start'} flexGrow={1} flexBasis={"50px"} flexDirection="column">
        {!hideFinalText && (
          <Box display="flex" justifyContent="flex-start" alignItems="center" flexWrap="wrap">
            {questionTimer > 0 && (
              <Box display="flex" justifyContent="flex-start" alignItems="center" flexDirection="column">
                <Typography style={{ fontFamily: 'Playfair Display, serif', color: '#d48aae', fontSize: 28, fontWeight: 'bold', letterSpacing: '0.08em', textShadow: '0px 4px 6px rgba(0,0,0,0.4)', marginBottom: 20 }}>TIME'S UP!</Typography>
                {drinkQuestion ? (
                  <Box display="flex" flexDirection="row" gap="8px" justifyContent="center" alignItems="center">
                    <BaseButton sx={btnSx} onClick={() => setPlayerAddShotAndSwap(playerOne)}>{playerOneName} drank..</BaseButton>
                    <BaseButton sx={btnSx} onClick={() => setPlayerAddShotAndSwap(playerTwo)}>{playerTwoName} drank..</BaseButton>
                    <BaseButton sx={btnSx} onClick={swapTurns}>Nailed it!</BaseButton>
                  </Box>
                ) : (
                  <Box display="flex" flexDirection="row" gap="8px" justifyContent="center" alignItems="center">
                    <BaseButton sx={btnSx} onClick={swapTurnsAndAddShot}>I'll just drink..</BaseButton>
                    <BaseButton sx={btnSx} onClick={swapTurns}>Managed to answer!</BaseButton>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        )}
      </Box>

      <PopoverCard
        open={drinkConfirmOpen}
        onClose={() => setDrinkConfirmOpen(false)}
        mainText="Are you sure you prefer to drink instead of answering your question?"
        showButtonOne={true}
        textButtonOne="Yes, I'll Drink"
        onButtonOne={() => { swapTurnsAndAddShot(); setDrinkConfirmOpen(false); }}
      />
      <PopoverCard
        open={skipConfirmOpen}
        onClose={() => setSkipConfirmOpen(false)}
        mainText="Are you sure you want to skip? Your partner will choose a different question for you!"
        showButtonOne={true}
        textButtonOne="Yes, Skip"
        onButtonOne={handleSkipConfirm}
      />
    </BackgroundContainer>
  );
};

export default TruthQuestionCard;
